module.exports = __webpack_public_path__ + "img/bg-green.a79c7e0a.png";